import Title from '../../microComponents/elements/Title';
import ComponentCard from '../../microComponents/elements/ComponentCard';
import UseSetParams from '../../microComponents/tablePages/filter/UseSetParams';
import DeleteFilterTable from '../../microComponents/tablePages/filter/DeleteFilterTable';
import CreatorTable from '../../microComponents/tablePages/CreatorTable';
import NotificationColumn from './NotificationColumn';


const Notification = () => {
  const [columns] = NotificationColumn();
  const [, handleDeleteParams] = UseSetParams();


  return (<div>
      <ComponentCard>
        <div className='flex justify-between'>
          <Title>هشدار ها</Title>
          <div className='flex gap-2 items-center'>
            <DeleteFilterTable onClick={handleDeleteParams} />
          </div>
        </div>
      </ComponentCard> <ComponentCard>

      <CreatorTable columns={columns} listAddress='warning'
                    expandable={{
                        expandedRowRender: (record) => (
                            <div className='flex gap-4 items-center flex-wrap'>
                                <div className='keyValue'>
                                    <div className="key">توضیحات: </div>
                                    <div className="value"> {record.description}</div>
                                </div>


                            </div>
                        ),
                        // rowExpandable: (record) => record.name !== 'Not Expandable',
                    }}



                    rowClassName={(record) => (record.levelId === 3 ? "tableRowBgRed" : record.levelId === 2 && 'tableRowBgOrange' )}
      />

    </ComponentCard></div>
  );
};


export default Notification;